import React from "react";
import { Link } from "react-router-dom";
import { useIsDarkMode } from "../../theme/ThemeContext";

const Footer = () => {
  const isDark = useIsDarkMode();

  return (
    // data-app-footer marks this as the element floating bottom-corner widgets
    // (components/Other/FeatureRequestBubble) have to stay clear of.
    <footer
      data-app-footer
      className="mt-12 border-t border-[color:var(--app-divider)] print:hidden"
    >
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-4 px-4 py-6 text-[color:var(--app-text)] sm:flex-row sm:px-6">
        <a
          href="https://bigclumber.com/"
          className="rounded-lg opacity-90 transition-opacity hover:opacity-100"
          aria-label="Big C Lumber website"
        >
          <img
            className="h-7 w-auto"
            src={
              isDark
                ? require("../../assets/BigCWhite.png")
                : require("../../assets/BigC.png")
            }
            alt="Big C Lumber"
          />
        </a>

        <nav
          aria-label="Footer"
          className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1 text-xs font-medium"
        >
          <Link to="/help" className="app-muted transition-colors hover:text-[color:var(--app-accent)]">
            Help &amp; FAQ
          </Link>
          <Link to="/status" className="app-muted transition-colors hover:text-[color:var(--app-accent)]">
            Site status
          </Link>
          <Link
            to="/forms/feature-request"
            className="app-muted transition-colors hover:text-[color:var(--app-accent)]"
          >
            Request a feature
          </Link>
          <span className="app-muted font-normal">
            © {new Date().getFullYear()} Big C Lumber™. All Rights Reserved.
          </span>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
